module.exports = __webpack_public_path__ + "static/screen01-b27d838160c4995305cdfaec85fb1a68.jpg";